import { Tag } from "antd";
import { WaterMeterChangeStatus } from "../enums/global.enums";
import { CSSProperties } from "react";

export function waterMeterChangeStatusTagPipe(value?: string | null, style?: CSSProperties) {
    switch (value) {
        case WaterMeterChangeStatus.Pending: return <Tag color="var(--warning-button)" style={style}>Chờ duyệt</Tag>;
        case WaterMeterChangeStatus.Confirmed: return <Tag color="var(--success-button)" style={style}>Đã xác nhận</Tag>;
        case WaterMeterChangeStatus.Cancelled: return <Tag color="var(--danger-button)" style={style}>Đã huỷ</Tag>;
    }
    return <Tag color="default" style={style}>Chưa cập nhật</Tag>;
}
